// IMGLIST-FR-061, IMG-OVW-FR-021: shared across ImagesListPage, Overview, and image-consuming
// components (CreateVolumeModal, RescueVmDialog, vms/helpers) so TPM model text isn't duplicated.
export const TPMModelText = {
  'tpm-crb': 'CRB',
  'tpm-tis': 'TIS',
}
